import { styled } from 'linaria/react';

export const StyledAlertWrap = styled.div`
  max-width: 396px;
  position: relative;
  width: calc(100% - 24px);
`;
